module.exports = __webpack_public_path__ + "img/tech_service_menue_4.c6dcbe11.png";